import styled from 'styled-components';

import { MediaQuery, FontSize } from '../styles/units';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    background: $base-white;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(39, 55, 128, 0.06);

    margin: 0 auto 90px;
    padding: 48px 24px;
    width: 350px;

    pointer-events: all;
    position: relative;
    font-size: ${FontSize.x_large};

    @media ${MediaQuery.S} {
        padding: 48px;
        width: 390px;
    }
`;
